import {
    MILESTONES_GET_STATUSES_LIST,
    MILESTONES_GET_STATUSES_LIST_SUCCESS,
    MILESTONES_GET_STATUSES_LIST_ERROR
} from './actions_def';

const INIT_STATE = {
    milestonesStatuses: [],
    errors: [],
    isLoading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case MILESTONES_GET_STATUSES_LIST:
            return { ...state, isLoading: false };

        case MILESTONES_GET_STATUSES_LIST_SUCCESS:
            return {
                ...state,
                isLoading: true,
                milestonesStatuses: action.payload,
            };

        case MILESTONES_GET_STATUSES_LIST_ERROR:
            return { ...state, isLoading: true, error: action.payload };


        default:
            return { ...state };
    }
};
